import { render } from "./image.vue?vue&type=template&id=92aec10e&scoped=true&ts=true"
import script from "./image.vue?vue&type=script&lang=ts"
export * from "./image.vue?vue&type=script&lang=ts"

import "./image.vue?vue&type=style&index=0&id=92aec10e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92aec10e"]])

export default __exports__